import { DiffContext } from 'app/state/contexts/DiffContext';
import React, { useContext } from 'react';
import ReactDataSheet from 'libs/react-datasheet';
import { resolveCellStyling } from 'app/utils/css';

export const DefaultTable = ({ id, data, locale, diff, side, showOriginalValue, cssClass }) => {
  const { diffState } = useContext(DiffContext);
  const isSelected = diffState?.right[data.superId]?.selected;

  return (
    <div id={id} contentEditable={false}>
      <ReactDataSheet
        readOnly={true}
        className={`table--reference-data${cssClass ? ' ' + cssClass : ''}`}
        data={data.selectionContent}
        valueRenderer={(cell) => {
          if (!!locale && !!cell.locales && Object.keys(cell.locales).length && !showOriginalValue) {
            /*
              This (next 3 rows) is a temporary bug fix. All the dates should be shown in swe format.
            */
            if (cell.rawData?.t === 'd') {
              return cell.locales['sv-SE'] || cell.value;
            }
            return cell.locales[locale] || cell.value;
          }
          return cell.value;
        }}
        cellRenderer={(props) => {
          const { row, col, cell, children, attributesRenderer, updated, editing, className: baseClassName, ...rest } = props;

          let style = {};
          const changed = diff?.[row]?.[col]?.some((diff) => diff[0] !== 0);
          const className = changed && side === 'right' ? `${baseClassName} ${isSelected ? 'diffed-change-selected' : 'diffed-change-added'}` : baseClassName;

          const { isHead, classes } = resolveCellStyling(cell);
          const Cell = isHead ? 'th' : 'td';

          let css = `${classes.join(' ')} ${!!cell.background ? cell.background : ''} ${!!cell.border ? cell.border : ''}`;

          if (cell.styling === 'bold') {
            return (
              <Cell className={`${className} ${css}`} {...rest} style={style}>
                <span className="xrp-bold xrp-table-bold">{props.children}</span>
              </Cell>
            );
          } else if (cell.styling === 'italic') {
            return (
              <Cell className={`${className} ${css}`} {...rest} style={style}>
                <span className="xrp-italic xrp-table-italic">{props.children}</span>
              </Cell>
            );
          } else if (cell.styling === 'underline') {
            /* <u> is not valid xhtml, use class instead */
            return (
              <Cell className={`${className} ${css}`} {...rest} style={style}>
                <span className="xrp-underline">{props.children}</span>
              </Cell>
            );
          }

          return (
            <Cell className={`${className} ${css}`} {...rest} style={style}>
              {props.children}
            </Cell>
          );
        }}
      />
    </div>
  );
};
